import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/default/button';
import { cssMap } from '@atlaskit/css';
import RetryIcon from '@atlaskit/icon/core/retry';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const styles = cssMap({
	body: {
		paddingBlock: token('space.150'),
		paddingInline: token('space.150'),
	},
	hiddenEditableBody: {
		height: 0,
		overflow: 'hidden',
		visibility: 'hidden',
	},
	noBodyError: {
		minHeight: '112px',
	},
});

interface Props {
	children?: React.ReactNode;
	contentRef: React.Ref<HTMLDivElement>;
	onRetry?: () => void;
}

export const NoBodyExecutionError = ({ children, contentRef, onRetry }: Props): JSX.Element => {
	const intl = useIntl();

	return (
		<Box xcss={styles.body}>
			<Stack
				alignBlock="center"
				alignInline="center"
				space="space.100"
				testId="agent-managed-extension-no-body-error"
				xcss={styles.noBodyError}
				role="alert"
			>
				<Text align="center" color="color.text.danger">
					{intl.formatMessage(messages.blockContentsFetchError)}
				</Text>
				<Button
					appearance="default"
					iconBefore={RetryIcon}
					isDisabled={!onRetry}
					onClick={onRetry}
					spacing="compact"
				>
					{intl.formatMessage(messages.retryBlockExecution)}
				</Button>
			</Stack>
			<Box xcss={styles.hiddenEditableBody} ref={contentRef}>
				{children}
			</Box>
		</Box>
	);
};
